import { Card, Col, Row, Collapse } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import RackRateList from "./RackRateList";

const { Panel } = Collapse;
const Index = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { data } = location?.state || {};

  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState("0");

  useEffect(() => {
    document.title = `Rack Rate List`;
    if (!data) {
      // If no data is passed, maybe redirect back or show a message
      console.warn("No rack rate data found in state.");
    }
  }, [data]);

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  if (!data || !Array.isArray(data)) {
    return (
      <div className="site-card-wrapper">
        <Row gutter={16}>
          <Col style={{ width: "100%" }}>
            <Card title={<span className="corp-title">Rack Rates List</span>} bordered={false}>
              <div style={{ textAlign: "center", padding: "20px" }}>
                No rack rate data found.
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="site-card-wrapper">
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <span className="corp-title">Rack Rates List</span>
              </div>
            }
            bordered={false}
          >
            <Collapse
              accordion
              activeKey={activeKey}
              onChange={handleCollapseChange}
              className="custom-collapse"
            >
              {data.map((item, index) => (
                <Panel
                  header={`Sum Insured: ${item.sum_insured}`}
                  key={index.toString()}
                >
                  <RackRateList
                    loading={loading}
                    filteredData={item?.rackrates_list || []}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                    }}
                  />
                </Panel>
              ))}
            </Collapse>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
